<template>
  <br />
</template>

<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {},
  mounted(){
  }
};
</script>

<style lang="scss" scoped>

</style>